/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import platform from '@/shared/utils/platform';
import {
  Vue, Component, Prop, Mixins,
} from 'vue-property-decorator';
import { RouterV2Enum } from '@/router/router-names';
import {
  androidRechargeAppDownloadUrl,
  androidSkzhenxhAppDownloadUrl,
  androidSpecialDownloadUrl,
  financeWeiXinMpUrlScheme,
  financeH5WebUrl,
  harmonyAppDownloadUrl,
  iosDownloadUrl,
  iosRechargeAppDownloadUrl,
  iosSkzhenxhAppDownloadUrl,
} from '@/constant';
import { iOSRedirect } from '@/shared/utils/iOSRedirect';
import isPrerendering from '@/shared/utils/isPrerendering';
import { clearNoExpectedNodeInPrerender, IS_PRERENDERING } from '@hb/coffee-prerender';
import { commonDispatchPreRender } from '@/shared/utils/prerenderHelper';
import { Toast } from '@hb/coffee';
import { getWisdomConfig } from '@/shared/wisdom';
import { PageVersionTypeEnums, EvokeAppTypeEnums } from './types';

import NewPage from './component/newPage';
import NewPageWithLogin from './component/newPageWithLogin';
import LandingPageNoLogo from './component/landPageNoLogo';
import SimplePage from './component/simplePage';

import MarketingLeaving from './component/newPageWithLogin/mixins';
import { EvokeAppRouteNames, pageConfigType, pageFeatureConfig } from './config';


const _isPrerendering = isPrerendering();

@Component({
  name: 'NewRedirect',
  beforeRouteEnter(to, __, next) {
    const type = to.query?.type || to.params?.type || '';
    let pageVersion = type as PageVersionTypeEnums;

    if (EvokeAppRouteNames.includes(to.name as RouterV2Enum)) {
      const evokeAppType = (to.params || {}).evokeAppType || (to.query || {}).evokeAppType;

      switch (evokeAppType) {
        case EvokeAppTypeEnums.RECHARGE:
          pageVersion = PageVersionTypeEnums.EVOKE_APP_MARKET_RECHARGE;
          break;
        case EvokeAppTypeEnums.FINANCE_WX_MP:
          pageVersion = PageVersionTypeEnums.EVOKE_APP_MARKET_FINANCE_WX_MP;
          break;
        case EvokeAppTypeEnums.SKZHENXH:
          pageVersion = PageVersionTypeEnums.EVOKE_APP_MARKET_SKZHENXH;
          break;
        default:
          pageVersion = PageVersionTypeEnums.SMSDOWNLOAD_HELLO_BIKE;
      }
    }

    const featureConfig = pageFeatureConfig.get(pageVersion);

    if (featureConfig && featureConfig.documentTitle) {
      to.meta.title = featureConfig.documentTitle;
    }

    next(async (vm: any) => {
      if (EvokeAppRouteNames.includes(vm.$route.name)) {
        vm.pageVersion = pageVersion;

        // 配合短链域名调整，不区分机型，进入落地页优先唤起app(“哈臻快”ios因未安装app时报错，暂关闭主动唤起能力)
        if (!(featureConfig && featureConfig.isCloseIosEvokeApp && platform.isIOS)) {
          vm.openAppWhenCreated();
        }
      } else {
        if (vm.$route.path === RouterV2Enum.newRedirect) {
          await vm.getPageVersion();
        } else {
          vm.pageVersion = pageVersion;
        }

        const notCallAppWhenEnter = (featureConfig && featureConfig.notCallAppWhenEnter);

        // 增加链接上携带参数进行是否一进入页面就唤起app的处理
        if (platform.isAndroid || platform.isHarmony) {
          if (!notCallAppWhenEnter && vm.callApp) {
            vm.openAppWhenCreated();
          }
        } else {
          if (!vm.hasLoginModulePage && vm.callApp) {
            vm.iosPopLogic();
          }
        }
      }
      vm.pageViewExpose();
    });
  },
})
export default class NewRedirect extends Mixins(MarketingLeaving) {
  @Prop(String) readonly phone!: string;

  @Prop(String) readonly source!: string;

  /** 是否走 abtest 流程
   * 默认走 abtest 逻辑分流，值为 true
   * 当值为 false 时，走新版本带登录样式且在h5流程里面做个人基本信息的填写 */
  @Prop(Boolean) readonly isAbtest!: boolean;

  /** 是否一进页面 直接跳转提现页-后续应用于直接触达提现页短信链接场景
   * 且有 ab 逻辑，40%比例直接跳提现页 */
  @Prop(Boolean) readonly isDirectApply!: boolean;

  /** 是否一进页面 直接唤起app */
  @Prop(Boolean) readonly callApp!: boolean;

  /** 短信链接唤起 app 类型 */
  @Prop(String) readonly evokeAppType!: EvokeAppTypeEnums

  private pageVersion: PageVersionTypeEnums | null = null;

  /* 用来区分是否是新版ab逻辑的营销落地下载页 */
  private newPageAb: boolean | null = null;

  /** 获取当前ab逻辑 */
  private async getAb(abKey?:string) {
    try {
      this.newPageAb = await Vue.prototype.$tangram.getAbTestResult({
        moduleCode: 'financial',
        keyCode: abKey || 'FinanceH5.LandingPageWithNewType',
      });
      return this.newPageAb;
    } catch {
      this.newPageAb = false;
      return false;
    }
  }

  // 包含登录模块页面
  private get hasLoginModulePage() {
    return [PageVersionTypeEnums.NEWVERSIONWITHLOGIN,
      PageVersionTypeEnums.BRANDVERSIONWITHLOGIN,
      PageVersionTypeEnums.BRAND_VERSION_WITHLOGIN_AND_INFO,
      PageVersionTypeEnums.BRANDVERSIONWITHLOGINANDINFO_WITHOUT_ANDROIDJUMP,
      PageVersionTypeEnums.BRANDVERSIONWITHELE,
      PageVersionTypeEnums.BRAND_VERSION_DOWNLOAD,
      PageVersionTypeEnums.BRAND_VERSION_COUPON,
      PageVersionTypeEnums.BRAND_VERSION_RISK,
      PageVersionTypeEnums.BRAND_VERSION_BAIDU,
      PageVersionTypeEnums.BRAND_VERSION_BAIDU_017,
      PageVersionTypeEnums.RIGHT_VERSION,
      PageVersionTypeEnums.BRAND_VERSION_RISK_BG,
      PageVersionTypeEnums.BRAND_VERSION_RISK_BG_018,
      PageVersionTypeEnums.BRANDVERSIONWITHLOGIN_019,
      PageVersionTypeEnums.BRAND_VERSION_BYTEDANCE_020,
      PageVersionTypeEnums.BRAND_VERSION_TENCENT_021,
      PageVersionTypeEnums.FINANCE_MAIN_BYTEDANCE,
      PageVersionTypeEnums.BRAND_AUTO_LOGIN_BYTEDANCE,
      PageVersionTypeEnums.BRAND_AUTO_LOGIN_TENCENT,
      PageVersionTypeEnums.BRAND_VERSION_TENCENT_029,
    ].includes(this.pageVersion as PageVersionTypeEnums);
  }

  // iOS 弹窗逻辑
  private iosPopLogic() {
    let featureConfig;
    if (this.pageVersion) {
      featureConfig = pageFeatureConfig.get(this.pageVersion);
    }
    if (!(featureConfig && featureConfig.iosNotOpenApp)) {
      this.openAppWhenCreated();
    }
    iOSRedirect();
  }

  private get featureConfig(): pageConfigType | null {
    if (this.pageVersion) {
      return pageFeatureConfig.get(this.pageVersion) || null;
    }

    return null;
  }

  /** 页面初始化埋点曝光事件上报 */
  private async pageViewExpose() {
    await this.getPopAbRes();
    this.$ubtModuleExpose(
      'finance_smsMarketing_landingPage_phoneMd5',
      'source',
      this.source,
      'phone',
      this.phone,
      'pageVersion',
      String(this.pageVersion),
      'backPopup',
      String(this.isHintAb),
    );
  }

  /** 弹窗唤起 app逻辑 Scheme Url */
  /** 页面加载后，已安装 app 用户，弹出 尝试打开 app弹窗 */
  private async openAppWhenCreated() {
    // 默认 跳臻有钱首页 RouterV2Enum.home = '/v2/home'
    let openPagePath = RouterV2Enum.home;
    let abTestSource = this.source;

    /** 预渲染模式，不唤起app */
    if (_isPrerendering) return;

    // 是否直达提现页
    if (this.isDirectApply) {
      try {
        const directApply = await Vue.prototype.$tangram.getAbTestResult({
          moduleCode: 'financial',
          keyCode: 'FinanceH5.LandingPageIsDirectApply',
        });
        if (directApply) {
          openPagePath = RouterV2Enum.applyProduct;
          abTestSource = `${this.source}_apply`;
        } else {
          openPagePath = RouterV2Enum.home;
          abTestSource = `${this.source}_home`;
        }
      } catch (error) {
        openPagePath = RouterV2Enum.home;
      }
    } else {
      openPagePath = RouterV2Enum.home;
    }

    if (EvokeAppTypeEnums.FINANCE_WX_MP === this.evokeAppType) {
      /** scheme唤起 臻有钱-微信小程序 */
      window.location.href = `${financeWeiXinMpUrlScheme}&path=pages/home/index&query=${encodeURIComponent(`source=${abTestSource}`)}`;
    } else if (EvokeAppTypeEnums.RECHARGE === this.evokeAppType) {
      /** scheme唤起 哈臻快app */
      window.location.href = `hlskrecharge://shzxbf.com?source=${abTestSource}`;
    } else if (EvokeAppTypeEnums.SKZHENXH === this.evokeAppType) {
      /** scheme唤起 记账app */
      // TODO: 待客户端提供scheme URL格式后再处理
      // window.location.href = `hlskzhenxh://shzxbf.com?source=${abTestSource}`;
    } else {
      window.location.href = `hellobike://hellobike.com/openWeb?webUrl=${financeH5WebUrl}#${openPagePath}?hiddenNavigationBar=1&source=${abTestSource}`;
    }
  }

  /** 页面内 ab 分流，获取当前用户命中营销页版本 */
  private async getPageVersion() {
    if (this.isAbtest) {
      try {
        const hasLoginModule = await Vue.prototype.$tangram.getAbTestResult({
          moduleCode: 'financial',
          keyCode: 'FinanceH5.LandingPageWithLogin',
        });
        if (hasLoginModule) {
          this.pageVersion = PageVersionTypeEnums.NEWVERSIONWITHLOGIN;
        } else {
          this.pageVersion = await this.getAb()
            ? PageVersionTypeEnums.NEWVERSION : PageVersionTypeEnums.NEW_VERSION_WITHAB;
        }
      } catch (error) {
        this.pageVersion = PageVersionTypeEnums.NEWVERSION;
        // eslint-disable-next-line no-console
        console.log(error);
      }
    } else {
      this.pageVersion = PageVersionTypeEnums.NEWVERSIONWITHLOGIN;
    }
  }

  /** 复制下载链接到剪切板 */
  private async copyDownloadLink() {
    let downloadUrl = '';
    const { channelDownloadUrl = '' } = this.featureConfig || {};
    if (platform.isIOS) {
      downloadUrl = iosDownloadUrl;
    } else if (platform.isAndroid) {
      downloadUrl = androidSpecialDownloadUrl;
    } else if (platform.isHarmony) {
      downloadUrl = harmonyAppDownloadUrl;
    } else {
      downloadUrl = androidSpecialDownloadUrl || channelDownloadUrl;
    }

    try {
      const { default: Clipboard } = await import('clipboard');
      const clipboard = new Clipboard('.copy-btn', {
        text: () => downloadUrl,
      });

      clipboard.on('success', () => {
        Toast('链接已复制到剪切板，请至浏览器粘贴并下载app');
        clipboard.destroy();
      });

      // 触发复制
      const copyBtn = document.createElement('button');
      copyBtn.className = 'copy-btn';
      copyBtn.style.display = 'none';
      document.body.appendChild(copyBtn);
      copyBtn.click();
      document.body.removeChild(copyBtn);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('复制失败:', err);
    }
  }

  /** 点击按钮 下载哈啰app */
  private async onRedirectApp() {
    this.$ubtPageButton(
      'finance_smsMarketing_landingPage_download',
      'source',
      this.source,
      'phone',
      this.phone,
      'pageVersion',
      String(this.pageVersion),
    );
    const { channelDownloadUrl = '', evokeAppType = '' } = this.featureConfig || {};
    const isRechargeAppMarket = evokeAppType === EvokeAppTypeEnums.RECHARGE;
    const isSkzhenxhAppMarket = evokeAppType === EvokeAppTypeEnums.SKZHENXH;

    // 028版本特殊处理
    if (this.pageVersion === PageVersionTypeEnums.BAI_XIN_DOWNLOAD_PAGE) {
      if (platform.isDouyinMini || platform.isWechatMini) {
        // 微信小程序或抖音小程序：复制下载链接
        this.copyDownloadLink();
        return;
      }
    }

    if (platform.isIOS) {
      if (isSkzhenxhAppMarket) {
        window.location.href = iosSkzhenxhAppDownloadUrl;
      } else if (isRechargeAppMarket) {
        window.location.href = iosRechargeAppDownloadUrl;
      } else if (this.hasLoginModulePage) {
        // iOS 页面 带登录模块，不下载，唤起弹窗
        this.iosPopLogic();
      } else {
        window.location.href = iosDownloadUrl;
      }
    } else if (platform.isAndroid) {
      if (isSkzhenxhAppMarket) {
        window.location.href = androidSkzhenxhAppDownloadUrl;
      } else if (isRechargeAppMarket) {
        window.location.href = androidRechargeAppDownloadUrl;
      } else {
        /** 腾讯018与029版本特殊处理,不跳转APK,跳转蹊径页 */
        const xjPageConfig = await getWisdomConfig<{ xjPageUrl: string }>('xjPageConfig');
        if (this.pageVersion === PageVersionTypeEnums.BRAND_VERSION_TENCENT_029
          || this.pageVersion === PageVersionTypeEnums.BRAND_VERSION_RISK_BG_018) {
          window.location.href = xjPageConfig.xjPageUrl;
        } else {
          // 取当前配置的渠道包下载地址，如果没有跳转默认001包
          window.location.href = channelDownloadUrl || androidSpecialDownloadUrl;
        }
      }
    } else if (platform.isHarmony) {
      window.location.href = harmonyAppDownloadUrl;
    }
  }

  private mounted() {
    if (IS_PRERENDERING) {
      commonDispatchPreRender();
      /** 删除预渲染内联style样式，实际有用的样式都是link引入 */
      clearNoExpectedNodeInPrerender('style');
    }
  }

  private render() {
    return (
      <div>
        {([PageVersionTypeEnums.NEWVERSION,
          PageVersionTypeEnums.BRANDVERSION,
          PageVersionTypeEnums.SMSDOWNLOAD_HELLO_BIKE,
          PageVersionTypeEnums.EVOKE_APP_MARKET_RECHARGE,
          PageVersionTypeEnums.EVOKE_APP_MARKET_SKZHENXH,
          PageVersionTypeEnums.NEW_VERSION_WITHAB,
          PageVersionTypeEnums.NOT_CALL_WHEN_ENTER_ELM,
          PageVersionTypeEnums.BAI_XIN_DOWNLOAD_PAGE,
        ].includes(this.pageVersion as PageVersionTypeEnums))
          && <NewPage
            onRedirectApp={this.onRedirectApp.bind(this)}
            pageVersion={this.pageVersion}
            isImmediateCall={this.newPageAb}
            evokeAppType={this.evokeAppType}
          />
        }
        {this.hasLoginModulePage
          && <NewPageWithLogin
            pageVersion={this.pageVersion}
            onRedirectApp={this.onRedirectApp.bind(this)}
            isAbtest={this.isAbtest}
          />
        }
        {
          this.pageVersion === PageVersionTypeEnums.EVOKE_APP_MARKET_FINANCE_WX_MP
          && (
            <SimplePage
              pageVersion={this.pageVersion}
              onEvokeApp={this.openAppWhenCreated.bind(this)}
            />
          )
        }
        {this.pageVersion === PageVersionTypeEnums.BRAND_VERSION_NOLGOO
          && <LandingPageNoLogo
            onRedirectApp={this.onRedirectApp.bind(this)}
          />
        }

      </div>
    );
  }
}
